<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-12 md:py-12 py-8">
    <div class="lg:pb-12 mdpb-10 pb-6">
      <p
        class="fsize40 md-fsize28 sm-fsize22 font-semibold clr-black text-center"
      >
        Want to be part of our videos?
      </p>
    </div>
    <div class="w-60per md-wfull sm-wfull mx-auto">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="lg:flex md:flex gap-4 lg:mb-6 md:mb-6 mb-4">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
              <p class="fsize12 clr-black">
                Full Name<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your first name"
                name="name"
                v-model="name"
                :rules="{ required: true, alpha_spaces: true }"
              ></base-input>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <p class="fsize12 clr-black">
                Phone Number<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your mobile number"
                name="mobile"
                v-model="mobile"
                :rules="{ required: true, numeric: true }"
                maxlength="10"
              ></base-input>
            </div>
          </div>
          <div class="lg:flex md:flex gap-4 lg:mb-6 md:mb-6 mb-4">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
              <p class="fsize12 clr-black clr-black">
                Email Address<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your email"
                name="email"
                v-model="email"
                :rules="{ required: true, email: true }"
              ></base-input>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <p class="fsize12 clr-black">
                Which podcast do you want to contribute to?<span class="clr-red"
                  >*</span
                >
              </p>
              <div>
                <!-- <el-select
                  class="w-full rounded-lg cust"
                  v-model="podcast"
                  placeholder="Ex: Gentle Warriors"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
                <base-input
                  class="rounded-lg w-full"
                  placeholder="Ex: Gentle Warriors"
                  name="podcast"
                  v-model="podcast"
                  :rules="{ required: true, max: 100 }"
                ></base-input>
              </div>
            </div>
          </div>

          <div class="w-full mb-4">
            <p class="fsize12 clr-black">
              Please give us more details about your organisation's needs<span
                class="clr-red"
                >*</span
              >
            </p>
            <base-input
              type="textarea"
              class="rounded-lg w-full"
              :rows="3"
              placeholder="Enter what your organization needs and how we can help."
              :rules="{ required: true }"
              name="description"
              v-model="description"
            >
            </base-input>
          </div>
          <div>
            <p class="fsize12">
              <span class="clr-red">*</span> Indicates a required field
            </p>
          </div>
          <div class="lg:mt-6 md:mt-6 mt-4 w-full">
            <div class="flex gap-2">
              <el-checkbox class="w-full" v-model="checked1"
                >By submitting the form, you agree to our terms of conditions
                and privacy policy.</el-checkbox
              >
            </div>
          </div>
          <div class="text-center lg:mt-10 md:mt-10 mt-6">
            <b-button
              :disabled="!checked1"
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
            >
              Submit Form</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      mobile: "",
      email: "",
      podcast: "",
      description: "",
      checked1: false,
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      textarea: "",
      input: "",
      value: "",
      checked1: false,
      checked2: false,
    };
  },
  methods: {
    async handleCreate() {
      try {
        let payload = {
          name: this.name,
          mobile: this.mobile,
          email: this.email,
          podcast: this.podcast,
          description: this.description,
          agreedTerms: this.checked1,
        };
        let data = await this.$store.dispatch("playlist/add_form", payload);
        this.$swal.fire({
          title: "Added",
          text: "Added Successfully!",
          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        this.resetForm();
      } catch (error) {
        console.log(error);
      }
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.podcast = "";
      this.description = "";
      this.checked1 = false;
      this.$refs.formValidator.reset();
    },
  },
  computed: {
    // ...mapState("services", { get_AllService: "get_AllService" }),
  },
  async mounted() {
    try {
      // const getServices = await this.$store.dispatch("services/get_all");
      // this.servicesOption = this.get_AllService.result.map((ele) => ({
      //   value: ele.title,
      //   label: ele.title,
      // }));
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
